var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, ModalHeader, ModalBody, Modal, ModalFooter, Input } from 'reactstrap';
import { fixDecimal } from '../../app/cart-logic';
import { ADDITIONAL_FIELD_TYPES, currency, } from '../../config';
import DishAdditionalField from './DishAdditionalField';
import DishHelper from './DishHelper';
import OtoSpinner from '../common/OtoSpinner';
import ChangeAmount from '../common/ChangeAmount';
import withIframeStyle from '../../containers/WithIframeStyle';
import IFRAME_STYLE_HELPER from '../../utils/iframe-style-helper';
import Shapes from 'Shapes';
var sortCheckboxesLast = function (a, b) {
    if (a.type === ADDITIONAL_FIELD_TYPES.CHECKBOX && b.type !== ADDITIONAL_FIELD_TYPES.CHECKBOX) {
        return 1;
    }
    if (b.type === ADDITIONAL_FIELD_TYPES.CHECKBOX && a.type !== ADDITIONAL_FIELD_TYPES.CHECKBOX) {
        return -1;
    }
    return 0;
};
var DishModal = function (props) {
    var _a, _b;
    var addToCart = props.addToCart, dish = props.dish, toggleModal = props.toggleModal;
    var _c = __read(useState(!!((_a = dish.priceOptions) === null || _a === void 0 ? void 0 : _a.length)
        ? dish.priceOptions[0]
        : dish), 2), selectedOption = _c[0], setSelectedOption = _c[1];
    var handleSelectChange = function (e) {
        var value = JSON.parse(e.target.value);
        setSelectedOption(value);
    };
    var _d = __read(useState(1), 2), amount = _d[0], setAmount = _d[1];
    var _e = __read(useState(''), 2), note = _e[0], setNote = _e[1];
    var additionalFields = dish.additionalFields || [];
    var getFieldDefaultValue = function (field) {
        if (field.type === ADDITIONAL_FIELD_TYPES.MULTIPLE_CHOICE) {
            return {};
        }
        if (field.type === ADDITIONAL_FIELD_TYPES.SINGLE_CHOICE) {
            return DishHelper.getFieldOptions(field)[0];
        }
        if (field.type === ADDITIONAL_FIELD_TYPES.CHECKBOX) {
            return false;
        }
        return null;
    };
    var defaultState = additionalFields.sort(sortCheckboxesLast).map(getFieldDefaultValue);
    var _f = __read(useState(defaultState), 2), fieldValues = _f[0], setFieldValues = _f[1];
    var changeFieldValue = function (field, newValue) {
        var idx = additionalFields.findIndex(function (f) { return f.name === field.name; });
        setFieldValues(__spreadArray(__spreadArray(__spreadArray([], __read(fieldValues.slice(0, idx)), false), [
            newValue
        ], false), __read(fieldValues.slice(idx + 1)), false));
    };
    var addonPrice = fieldValues.reduce(function (price, fieldValue, index) {
        var field = additionalFields[index];
        if (field.type === ADDITIONAL_FIELD_TYPES.CHECKBOX && !!fieldValue) {
            return price + parseFloat(field.addonPrice.toString());
        }
        return price;
    }, 0);
    var dishTotalPrice = selectedOption.price + addonPrice;
    var _g = __read(useState(false), 2), loading = _g[0], setLoading = _g[1];
    var _h = __read(useState(null), 2), error = _h[0], setError = _h[1];
    var addOptionToCart = function () {
        var _a;
        setLoading(true);
        var dishWithAdditionalFields = __assign(__assign(__assign(__assign({}, dish), { name: dish.name }), (!!((_a = dish.priceOptions) === null || _a === void 0 ? void 0 : _a.length) ? { option: selectedOption.name } : {})), { price: dishTotalPrice, amount: amount, selectedAdditionalFields: DishHelper.getDishAdditionalFields(additionalFields, fieldValues), notes: note });
        addToCart(dishWithAdditionalFields).then(function () {
            setLoading(false);
            toggleModal();
        })
            .catch(function (e) {
            e.message && setError(e.message);
            setLoading(false);
        });
    };
    var additionalSelectFields = additionalFields.filter(function (f) { return f.type !== ADDITIONAL_FIELD_TYPES.CHECKBOX; });
    var additionalCheckboxFields = additionalFields.filter(function (f) { return f.type === ADDITIONAL_FIELD_TYPES.CHECKBOX; });
    var _j = __read(useState(5), 2), checkboxFieldsVisibleAmount = _j[0], setCheckboxFieldsVisibleAmount = _j[1];
    var renderAdditionalField = function (additionalField, index) {
        return React.createElement(DishAdditionalField, { key: additionalField.name, field: additionalField, fieldValue: fieldValues[additionalField.type === ADDITIONAL_FIELD_TYPES.CHECKBOX ? index + additionalSelectFields.length : index], changeFieldValue: changeFieldValue });
    };
    return React.createElement(Modal, { isOpen: true, toggle: toggleModal, style: props.iframeStyle.dishModal },
        React.createElement(ModalHeader, { toggle: toggleModal }, dish.name),
        React.createElement(ModalBody, { className: "pt-0", style: props.iframeStyle.dishModalBody },
            (!!((_b = dish.priceOptions) === null || _b === void 0 ? void 0 : _b.length))
                ? React.createElement("div", { className: "dish__options" },
                    React.createElement("div", null,
                        React.createElement("strong", { className: "dish-modal__field-title" }, "Wybierz produkt:")),
                    React.createElement("select", { className: "form-control", onChange: handleSelectChange, value: JSON.stringify(selectedOption) }, (dish.priceOptions || []).map(function (opt) { return (React.createElement("option", { key: opt.name, value: JSON.stringify(opt) },
                        opt.name,
                        " (",
                        opt.price,
                        " ",
                        currency,
                        ")")); })))
                : null,
            additionalSelectFields.map(renderAdditionalField),
            additionalCheckboxFields.slice(0, checkboxFieldsVisibleAmount).map(renderAdditionalField),
            (checkboxFieldsVisibleAmount < additionalCheckboxFields.length)
                && React.createElement(Button, { color: "link", type: "button", onClick: function () { return setCheckboxFieldsVisibleAmount(additionalCheckboxFields.length); } }, "poka\u017C wi\u0119cej"),
            React.createElement("div", { className: "mt-2" },
                React.createElement("strong", { className: "dish-modal__field-title" }, "Dodatkowe uwagi:"),
                React.createElement(Input, { type: "textarea", value: note, onChange: function (e) { return setNote(e.target.value); }, placeholder: "Np. czego nie tolerujesz lub inne informacje" }))),
        React.createElement(ModalFooter, { className: "d-flex justify-content-around flex-wrap" },
            error && React.createElement("div", { className: "font-weight-bold  mb-2 mx-0 row text-danger" }, error),
            React.createElement("div", { className: "row flex-nowrap mx-0 w-100" },
                React.createElement(ChangeAmount, { disableDecrease: amount === 1, onUpdateValue: setAmount, value: amount, suffix: "szt.", wrapperClass: "row mx-0 align-items-center flex-nowrap flex-fill" }),
                loading
                    ? React.createElement("div", { className: "flex-fill" },
                        React.createElement(OtoSpinner, null))
                    : React.createElement(Button, { color: "primary", className: "flex-fill", type: "button", onClick: addOptionToCart },
                        "Dodaj: ",
                        fixDecimal(dishTotalPrice * amount).toFixed(2),
                        "\u00A0",
                        currency))));
};
DishModal.propTypes = {
    addToCart: PropTypes.func.isRequired,
    dish: Shapes.restaurantMenuItemWithCategoryShape.isRequired,
    toggleModal: PropTypes.func.isRequired,
};
var calculateStyle = function (pageInfo) {
    return {
        dishModal: IFRAME_STYLE_HELPER.getDishModalStyle(pageInfo),
        dishModalBody: IFRAME_STYLE_HELPER.getDishModalBodyStyle(pageInfo),
    };
};
export default withIframeStyle(DishModal, calculateStyle, { repaintOnInit: true });
